module.exports = __webpack_public_path__ + "img/LTS_KPMG_NAM.c9dc0808.gif";